import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Estilo para miniaturas con encuadre (posición) + zoom.
// El recorte lo hace `object-cover`; `objectPosition` mueve el foco y `transform: scale`
// hace zoom alrededor de ese mismo punto. Requiere que el contenedor recorte (overflow-hidden).
export function thumbStyle(position, zoom) {
  const pos = position || 'center';
  const z = Number(zoom) || 1;
  return {
    objectPosition: pos,
    transformOrigin: pos,
    transform: z !== 1 ? `scale(${z})` : undefined,
  };
}
